import React, {Fragment} from "react";

export default function MultilineText({text}){
  return <>
    {text.split(/\n\r?/g).map((line, index) => <Fragment key={index}>{line}<br/></Fragment>)}
  </>
}